<template>
  <div class="service view-conten">
    <!-- banner区域 -->
    <div class="service-banner">
      <div class="banner-title">
        <div class="main-title">优化服务以供应链高效运营为目标</div>
        <div class="subtitle">
          端到端信息化规划 / 实施 / 开发 / 运维 / 优化服务
        </div>
        <div class="title-btn" @click="handleContact">预约演示</div>
      </div>
      <img src="../assets/service/service-banner.jpg" alt="" />
    </div>
    <!-- 内容区域 -->
    <div class="service-content">
      <!-- 业务规划 -->
      <div class="service-intr-card">
        <div class="card-title">
          <div class="card-title-name">业务规划</div>
          <div class="card-title-content">
            从企业采购管理现状及发展战略出发，协助进行采购数字化转型规划并形成具体落地方案
          </div>
        </div>
        <!-- 图片区 -->
        <img src="../assets/service/businessPlan.jpg" alt="" />
      </div>
      <!-- 实施服务 -->
      <div class="service-intr-card">
        <img src="../assets/service/implementService.jpg" alt="" />
        <div class="card-title">
          <div class="card-title-name">实施服务</div>
          <div class="card-title-content">
            通过成熟的项目管理方法指引，并由PMO在项目进度、项目质量、资源协调等方面进行监管，保证成功交付
          </div>
        </div>
        <!-- 图片区 -->
      </div>
      <!-- 持续跟踪优化 -->
      <div class="service-intr-card">
        <!-- 标题区 -->
        <div class="card-title">
          <div class="card-title-name">持续跟踪优化</div>
          <div class="card-title-content">
            日常使用过程中，服务顾问将全程跟踪您的使用情况，定期回访，共同对企业供应链管理进行持续优化
          </div>
        </div>
        <!-- 图片区 -->
        <img src="../assets/service/continuousFollow.jpg" alt="" />
      </div>

      <!--  -->
    </div>
    <div class="service-speed">
      <div class="service-speed-content">
        <div class="main-title">提供7*24小时应急响应服务保障</div>
        <div class="second-title">快速响应、快速处理、及时反馈、保证系统平稳运行</div>
        <div class="service-speed-icon">
          <div class="icon-item">
            <img src="../assets/service/system.png" alt="">
            <div class="">售后平台</div>
          </div>
          <div class="icon-item">
            <img src="../assets/service/email.png" alt="">
            <div class="">邮箱</div>
          </div>
          <div class="icon-item">
            <img src="../assets/service/phone.png" alt="">
            <div class="">电话</div>
          </div>
          <div class="icon-item">
            <img src="../assets/service/qq.png" alt="">
            <div class="">售后平台</div>
          </div>
        </div>
      </div>
    </div>

    <registerDialog :show.sync="show"/>
  </div>
</template>

<script>
import registerDialog from '@/components/register-dialog'

export default {
  components: {registerDialog},
  data () {
    return {
      show: false
    }
  },
  methods: {
    handleContact () {
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.service {
  width: 100%;
  .service-banner {
    position: relative;
    .banner-title {
      color: #ffffff;
      position: absolute;
      width: 1200px;
      margin: 0 auto;
      top: 62px;
      left: 0;
      right: 0;
      .main-title {
        font-size: 46px;
        color: #ffffff;
        line-height: 75px;
      }
      .subtitle {
        margin-top: 12px;
        font-size: 30px;
        color: #ffffff;
      }
      .title-btn {
        margin-top: 40px;
        width: 134px;
        height: 40px;
        background: #0c55dd;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        border-radius: 3px;
      }
    }
    img {
      width: 100%;
      height: 368px;
    }
  }
  .service-content {
    margin: 0 auto;
    width: 1200px;
    padding-top: 53px;
    .service-intr-card {
      display: flex;
      margin-bottom: 50px;
      .card-title {
        width: 670px;
        .card-title-name {
          margin-top: 93px;
          font-size: 28px;
          color: #333333;
          font-weight: bolder;
        }
        .card-title-content {
          margin-top: 22px;
          width: 601px;
          font-size: 16px;
          color: #333333;
          line-height: 28px;
        }
      }
      img {
        width: 530px;
        height: 300px;
      }
    }
    .service-intr-card:nth-child(2n) .card-title {
      padding-left: 42px;
    }
  }
  .service-speed {
    height: 368px;
    width: 100%;
    background: url('../assets/service/service-bg2.jpg') no-repeat 100% 100%  ;
    background-size: cover;
    color: #fff;
    .service-speed-content{
      padding-top: 52px;
      margin: 0 auto;
      width: 1200px;
      .main-title{
        font-size: 34px;
        font-weight: bold;
        line-height: 58px;
      }
      .second-title{
        font-size: 28px;
        line-height: 58px;
      }
      .service-speed-icon{
        display: flex;
        align-items: center;
        .icon-item{
          margin-top: 62px;
          margin-right: 102px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img{
            margin-bottom: 16px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/service.vue